var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCards(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8251 0.199951H2.1751C1.30524 0.199951 0.600098 0.852326 0.600098 1.65709V12.3428C0.600098 13.1476 1.30524 13.8 2.1751 13.8H15.8251C16.695 13.8 17.4001 13.1476 17.4001 12.3428V1.65709C17.4001 0.852326 16.695 0.199951 15.8251 0.199951ZM7.9501 11.8571H2.7001V4.08567H7.9501V11.8571ZM15.3001 11.8571H10.0501V4.08567H15.3001V11.8571Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCards);
export default __webpack_public_path__ + "static/media/cards.77edba4344fe5f5cc78d8781aead9979.svg";
export { ForwardRef as ReactComponent };